<template>
  <div v-if="textmessages && !loadingTextmessages">
    <div v-for="textmessage in textmessages" :textmessage="textmessage" class="card mt-3">
      <div class="card-body p-2 card-message" v-html="textmessage"></div>
    </div>
  </div>
</template>

<script>
  import { FETCH_TEXTMESSAGES } from '../../store/types'

  export default {
    data() {
      return {
        showTextmessage: false
      }
    },
    computed: {
      loadingTextmessages() {
        return this.$store.getters.loadingTextmessages
      },
      textmessages() {
        return this.$store.getters.textmessages
      },
    },
    updated() {
      this.showTextmessage = this.$store.getters.textmessages
    },
    created() {
      this.$store.dispatch(FETCH_TEXTMESSAGES)

      this.showTextmessage = true
    }
  }
</script>

<style lang="scss" scoped>
</style>
